module.exports = __webpack_public_path__ + "static/media/profile_image.3a1d3c69.png";